import { createAsyncThunk } from '@reduxjs/toolkit';

import VerificationProcessApi from 'api/curo/VerificationProcessApi';
import { VerificationProcessActionType } from 'enums/curo/VerificationProcessActionType';
import { RequestError } from 'errors/RequestError';

export const createSendPhoneVerificationCodeThunk = (api: VerificationProcessApi) =>
  createAsyncThunk(
    VerificationProcessActionType.SendPhoneVerificationCode,
    async (
      { applicationId, phone }: { applicationId: string; phone: string },
      { rejectWithValue },
    ) => {
      try {
        const response = await api.sendPhoneVerificationCode(applicationId, phone);
        return response;
      } catch (error) {
        if (error instanceof RequestError) {
          return rejectWithValue({
            responseStatus: error.responseStatus,
            errorType: error.errorType,
            message: error.message,
          });
        }

        throw error;
      }
    },
  );
